import { requestApiClient, requestApiUser } from "../functions";

export default {
    create: async () => {
        const res = await requestApiClient(
            "/commands",
            "POST",
            {}
        );
        return res;
    },

    findAll: async () => {
        const res = await requestApiUser(
            "/commands",
            "GET"
        );
        return res;
    },
    findById: async (id) => {
        const res = await requestApiClient(
            `/commands/${id}`,
            "GET"
        );
        return res;
    },
    update: async (id, data) => {
        const res = await requestApiUser(
            `/commands/${id}`,
            "PUT",
            data
        );
        return res;
    },
    updateClientAddress: async (id, data) => {
        const res = await requestApiClient(
            `/commands/${id}/client-address`,
            "PUT",
            data
        );
        return res;
    },
    delete: async (id) => {
        const res = await requestApiUser(
            `/commands/${id}`,
            "DELETE"
        );
        return res;
    },
    editProductsForCommand: async (commandId, variantId, quantity) => {
        const res = await requestApiClient(
            `/commands/${commandId}/products/${variantId}`,
            "PUT",
            { quantity }
        );
        return res;
    },
    getPaymentUrl: async (commandId) => {
        const res = await requestApiClient(
            `/commands/payment/${commandId}`,
            "GET"
        );
        return res;
    },
    findAllByClientPaid: async () => {
        const res = await requestApiClient(
            `/commands/client/paid`,
            "GET"
        );
        return res;
    }
}